import { useKeenSlider } from "keen-slider/react";
import React from "react";
import {
    teamImg1,
    teamImg2,
    teamImg3,
    teamImg4,
    teamImg7,
    teamImg8,
    teamImg9,
} from "../../assets/img";
import "./MeetTheTeam.css";
import "keen-slider/keen-slider.min.css";
import { Link } from "react-router-dom";

function MeetTheTeam() {
    const animation = { duration: 30000, easing: (t) => t };
    const [sliderRef1] = useKeenSlider({
        breakpoints: {
            "(min-width: 576px)": {
                slides: { perView: 2, spacing: 15 },
            },
            "(min-width: 768px)": {
                slides: { perView: 3, spacing: 15 },
            },
            "(min-width: 1024px)": {
                slides: { perView: 4, spacing: 15 },
            },
            "(min-width: 1400px)": {
                slides: { perView: 5, spacing: 15 },
            },
        },

        slides: {
            perView: 1,
            spacing: 15,
        },
        loop: true,
        renderMode: "performance",
        drag: false,
        created(s) {
            s.moveToIdx(5, true, animation);
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
    });

    return (
        <section className="mtt_wrap spacing">
            <div className="mtt ">
                <h4 className="container">Meet the team</h4>
                <div className="team-wrap keen-slider" ref={sliderRef1}>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg7} alt="Mohit" />
                            <div className="overlay">
                                <p>Creativity mind </p>
                                <p className="cambon_font">but only in night.</p>
                            </div>
                        </div>
                        <h6>Mohit</h6>
                        <p className="cambon_font">UX Designer</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg1} alt="Rahul Lodhi" />
                            <div className="overlay">
                                <p>Exploring & Learning </p>
                                <p className="cambon_font">new Technologies.</p>
                            </div>
                        </div>
                        <h6>Rahul Lodhi</h6>
                        <p className="cambon_font">Full Stack Developer</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg2} alt="Kuldeep" />
                            <div className="overlay">
                                <p>Multipurpose tech mind </p>
                                <p className="cambon_font">with attractive nature.</p>
                            </div>
                        </div>
                        <h6>Kuldeep </h6>
                        <p className="cambon_font">Frontend Developer</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg4} alt="Nandini" />
                            <div className="overlay">
                                <p>Capable, communicative, cheerful.</p>
                                <p className="cambon_font">and fearless.</p>
                            </div>
                        </div>
                        <h6>Nandini </h6>
                        <p className="cambon_font">Frontend Developer</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg3} alt="" />
                            <div className="overlay">
                                <p>Silent backend </p>
                                <p className="cambon_font">code artist.</p>
                            </div>
                        </div>
                        <h6>Neeraj</h6>
                        <p className="cambon_font">Backend Developer</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg8} alt="Sachin" />
                            <div className="overlay">
                                <p>Fully stacked and packed</p>
                                <p className="cambon_font">with skills.</p>
                            </div>
                        </div>
                        <h6>Sachin</h6>
                        <p className="cambon_font">App Developer(Fullstack)</p>
                    </div>
                    <div className="t-item keen-slider__slide">
                        <div className="img-wrap">
                            <img src={teamImg9} alt="Chandini" />
                            <div className="overlay">
                                <p>Connecting us </p>
                                <p className="cambon_font">
                                    to outside the world and create opportunities.
                                </p>
                            </div>
                        </div>
                        <h6>Chandini</h6>
                        <p className="cambon_font">Digital Marketing Expert</p>
                    </div>
                </div>
                <div className="last-cart">
                    <div className="lc_inner container">
                        <Link className="animateLine" to="/about">
                            Meet Everyone
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MeetTheTeam;
